import { useLazyQuery, gql } from '@apollo/client'
import { useNavigate } from 'react-router-dom'

const OPERATION_EXTEND_DEVICE_QUERY = gql`
  query FindExtendDevice($uuid: ID!) {
    equipment: findExtendDevice(uuid: $uuid) {
      uuid
      position {
        map {
          uuid 
          surface_area {
            uuid
          }
        }
      }
    }
  }
`

const OPERATION_FIND_DEVICE_BY_MAC = gql`
  query FindDeviceUuidByMac($mac: String!) {
    uuid: findDeviceUuidByMac(mac: $mac)
  }
`

const OPERATION_FIND_PARENT_DEVICE = gql`
  query FindGroupParentDeviceUuid($uuid: ID!) {
    uuid: findGroupParentDeviceUuid(uuid: $uuid)
  }
`


const useGoToMap = () => {
  const [findExtendDevice, queryExtend] = useLazyQuery(OPERATION_EXTEND_DEVICE_QUERY)
  const [findDeviceByMac] = useLazyQuery(OPERATION_FIND_DEVICE_BY_MAC)
  const [findParentDevice] = useLazyQuery(OPERATION_FIND_PARENT_DEVICE)
  const navigate = useNavigate()

  const fetchUuid = async (mac: string) => {
    const device = await findDeviceByMac({ variables: { mac } })
    if (!device.data?.uuid) {
      return null
    }
    const parent = await findParentDevice({ variables: { uuid: device.data.uuid } })
    return parent.data?.uuid || device.data.uuid
  }

  const fetchPosition = async (uuid: string) => {
    const { data } = await findExtendDevice({ variables: { uuid } })
    const floorUuid = data?.equipment?.position?.map?.uuid
    const buildingUuid = data?.equipment?.position?.map?.surface_area?.uuid
    return {
      floorUuid,
      buildingUuid
    }
  }

  return {
    go: async ({ mac, siteId }:{mac: string, siteId: string}) => {
      const uuid = await fetchUuid(mac)
      if (!uuid) {
        return null
      }
      const { buildingUuid, floorUuid } = await fetchPosition(uuid)
      if (floorUuid && buildingUuid) {
        navigate(`/monitoring/map/${siteId}/${buildingUuid}/${floorUuid}/${uuid}`)
      }
    },
    loading: queryExtend.loading,
    error: queryExtend.error ? queryExtend.error.message : null
  }
}

export default useGoToMap
